'use strict';

var _ = require('lodash');
var DataAggregationFactory = function DataAggregationFactory() {
  function DataAggregation(sourceType, targetType) {
    this.sourceType = sourceType;
    this.targetType = targetType;
    this.calculatedFields = require('../../config/yieldCalculationConfig.json');
  }
  DataAggregation.prototype.canAggregate = function (sourceType, targetType) {
    var applicableSourceType = _.isArray(this.sourceType) ? this.sourceType.indexOf(sourceType) > -1 : this.sourceType === sourceType;
    var isProperSourceType = applicableSourceType || this.sourceType === 'any';
    var isProperTargetType = this.targetType === targetType || this.targetType === 'any';
    return isProperSourceType && isProperTargetType;
  };
  DataAggregation.prototype.aggregate = function () {
    throw new Error('method not implemented');
  };
  DataAggregation.prototype.sortAggregationResults = function (groups, groupKeySort) {
    var groupsKeys = Object.keys(groups);
    var sortedGroups = [];
    groupsKeys.sort(function (a, b) {
      if (groupKeySort && {}.toString.call(groupKeySort) === '[object Function]') {
        a = groupKeySort(a);
        b = groupKeySort(b);
      }
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
    for (var index = 0, groupsKeysLength = groupsKeys.length; index < groupsKeysLength; index++) {
      sortedGroups.push(groups[groupsKeys[index]]);
    }
    return sortedGroups;
  };
  DataAggregation.prototype.reduceEntries = function (group, keys, reducedEntry) {
    for (var groupIndex = 0, groupLength = group.length; groupIndex < groupLength; groupIndex++) {
      for (var keysIndex = 0, keysLength = keys.length; keysIndex < keysLength; keysIndex++) {
        var value = group[groupIndex][keys[keysIndex]];
        var aggregatedValue = reducedEntry[keys[keysIndex]];
        if (!_.isUndefined(value)) {
          reducedEntry[keys[keysIndex]] = (aggregatedValue || 0) + value;
        }
      }
    }
  };
  DataAggregation.prototype.reduceEntriesYield = function (metrics, group, keys, reducedEntry) {
    var calculatedKeys = Object.keys(this.calculatedFields);
    for (var groupindex = 0, groupLength = group.length; groupindex < groupLength; groupindex++) {
      var element = group[groupindex];
      for (var keyIdx = 0; keyIdx < calculatedKeys.length; keyIdx++) {
        var v = this.calculatedFields[calculatedKeys[keyIdx]];
        if (_.isNumber(element[v.left]) && _.isNumber(element[v.right])) {
          reducedEntry[v.left] = (reducedEntry[v.left] || 0) + element[v.left];
          reducedEntry[v.right] = (reducedEntry[v.right] || 0) + element[v.right];
        }
      }
    }
    _.forEach(this.calculatedFields, function (v, k) {
      var n = reducedEntry[v.left];
      var d = reducedEntry[v.right];
      reducedEntry[k] = d && _.isNumber(n) ? n / d : undefined;
    });
    for (var m = 0; m < metrics.length; m++) {
      var curMetricName = metrics[m];
      reducedEntry[keys[m]] = reducedEntry[curMetricName];
    }
  };
  function isYieldField(metricNames) {
    return metricNames.indexOf('yield') !== -1 || metricNames.indexOf('Yield') !== -1;
  }
  DataAggregation.prototype.getAggregationFunction = function (metrics) {
    var isYield = metrics && isYieldField(metrics.join('-'));
    return isYield ? this.reduceEntriesYield.bind(this, metrics) : this.reduceEntries;
  };
  DataAggregation.prototype.mergeCurveData = function (data, curveConfig) {
    var curves = [];
    var minDtd = 360;
    var maxDtd = 0;
    var isCurrentYear = _.includes(curveConfig.curveName, 'CurrentYear');
    _.forEach(data, function (entry) {
      if (entry[curveConfig.curveName] === undefined) {
        return;
      }
      var curve = entry[curveConfig.curveName];
      curve.current = 0;
      curves.push(curve);
      _.forEach(curve, function (dataPoint) {
        if (dataPoint.daysToDeparture < minDtd) {
          minDtd = dataPoint.daysToDeparture;
        }
        if (dataPoint.daysToDeparture > maxDtd) {
          maxDtd = dataPoint.daysToDeparture;
        }
      });
    });
    var result = [];
    if (curves.length === 0) {
      return result;
    }
    if (!isCurrentYear) {
      minDtd = 0;
    }
    if (maxDtd >= minDtd) {
      _.forEach(_.range(maxDtd, minDtd - 1), function (dtd) {
        var val = _.reduce(curves, function (sum, curve) {
          var dataPoint = _.find(curve, {
            daysToDeparture: dtd
          });
          if (dataPoint) {
            curve.current = dataPoint[curveConfig.metric];
          }
          if (!_.isUndefined(curve.current)) {
            sum = (curveConfig.isStringType ? '' : sum || 0) + curve.current;
          }
          return sum;
        }, undefined);
        if (curveConfig.metric === 'loadFactor' && !_.isUndefined(val)) {
          val = val * 100;
        }
        result.push({
          value: val,
          dtd: dtd
        });
      });
    }
    return _.chain(result).sortBy('dtd').value();
  };
  return DataAggregation;
};
DataAggregationFactory.$inject = [];
module.exports = DataAggregationFactory;